module.exports = __webpack_public_path__ + "ak.no1.7ca2f402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ak.no1.jpg
// module id = iqtQ
// module chunks = 0